module.exports = __webpack_public_path__ + "static/media/ios_0_600.b19eb779.png";